import { Checkbox, Col, DatePicker, Form, Icon, Input, InputNumber, Row } from 'antd'
import CustomSpin from '../../../elements/CustomSpin'
import DeliveryDetails from '../../../elements/DeliveryDetails'
import withSort from '../../../elements/HOC/withSort'
import withSpinning from '../../../elements/HOC/withSpinning'
import useFetchSelectUrl from '../../../elements/Hooks/useFetchSelectUrl'
import { useForceUpdate } from '../../../elements/Hooks/useForceUpdate'
import MultiCurrency from '../../../elements/MultiCurrency'
import CountrySelect from '../../../elements/Select/Country'
import CustomSelect from '../../../elements/Select/CustomSelect'
import withData from '../../../elements/Select/withData'
import withUrlFetch from '../../../elements/Select/withUrlFetch'
import { get, isEmpty } from 'lodash'
import { defaultFormItemLayout, fullWidthFormItemLayout, rules, threeFormItemLayout, boolLabelItemLayout } from '../../../modules/FormItems'
import { dateVal, findCascadersParents } from '../../../modules/Utils'
import moment from 'moment'
import React, { Fragment, useEffect } from 'react'

import { Link } from 'react-router-dom'
import { compose } from 'recompose'
import IconText from '../../../elements/IconText'
import InfoTooltip from '../../../elements/InfoTooltip'
import RegisteredPartnerDetails from '../../../elements/RegisteredPartnerDetails'
import withSelectFetch from '../../../elements/Select/withSelectFetch'
import Taxes from '../../../elements/Taxes'
import useFetchURL from '../../../elements/Hooks/useFetchURL'
import CustomCascader from '../../../elements/Select/CustomCascader'

const { TextArea } = Input

function ReadyToOrderForm(props) {
  const {
    order,
    selectionData,
    lines,
    VendorQuote,
    VendorQuoteLine,
    fetchingVendorQuoteLine,
    fetchingVendorQuote,
    fetchingOrders,
    fetching,
    isNew,
    centers,
  } = props

  const { getFieldDecorator, getFieldValue, setFieldsValue, resetFields } = props.form

  const max = selectionData && selectionData.reduce((sum, x) => x.max + sum, 0)
  const owner = (getFieldValue('vendor._id') || '').replace('members/', '')
  const type = get(order, '[0].orderType') || get(selectionData, '[0].type')
  const isService = type === 'Service'

  const isReqSale = !!selectionData ? !!get(selectionData, '[0].sales._id') : !!get(order, 'reqs[0].sales._id')

  const profitCenter = get(selectionData, '[0].budgetLine.centers._id')
  const centersArray = findCascadersParents(centers, profitCenter, 1)
  const quoteId = (getFieldValue('quote._id') || '').replace('spquotes/', '')

  const [QuoteSelect] = useFetchSelectUrl(
    {
      name: 'quotations',
      url: `/vendorQuotes?select=*&status=Confirmed&owner=${owner}`,
      forceFetch: false,
      cache: true,
    },
    [owner],
    isEmpty(owner),
    undefined,
    ({ quoteNo, title, ...quote }) => ({
      display: `[${quoteNo}] ${title}`,
      ...quote,
    })
  )

  const { data, fetchURL } = useFetchURL(`/foxxapi/dropdowns/requisitions/orderType`)
  const OrderTypeSelect = compose(
    withSpinning,
    withData({
      data: data,
      fetch: fetchURL,
      fetching: fetching,
    }),
    withSort
  )(CustomCascader)

  const isCollection = getFieldValue('isCollection')
  const typeValue = getFieldValue('valueType')

  const collectionCountry = getFieldValue('collection.address.country') || get(order, 'collection.address.country', '')

  const CollectionLocationSelect = compose(
    withUrlFetch({
      name: 'collectionLocation',
      url: `location/${collectionCountry}`,
      cache: false,
    }),
    withSpinning
  )(CustomSelect)

  const [showDesc, setShowDesc] = React.useState(() => !isEmpty(order.description))

  const forceUpdate = useForceUpdate()
  useEffect(() => {
    if (isNew) {
      order.vendor = { _id: get(VendorQuote, 'vendor._id') }
      order.vendorRep = { _id: get(VendorQuote, 'vendorRep._id') }
      order.company = { _id: get(VendorQuote, 'company._id') }
      order.companyRep = { _id: get(VendorQuote, 'companyRep._id') }
      order.contract = { _id: get(VendorQuote, 'contract._id') }
      order.delivery = get(VendorQuote, 'delivery')
      order.tax = get(VendorQuoteLine, 'tax')
    }
    forceUpdate()
  }, [fetchingVendorQuoteLine, fetchingVendorQuote, fetchingOrders, fetching])

  //console.log({isReqSale}, selectionData)
  return (
    <CustomSpin spinning={fetchingVendorQuoteLine || fetchingVendorQuote || fetchingOrders || fetching}>
      <Form>
        <Row>
          <Row>
            <RegisteredPartnerDetails
              doc={{
                centers: centersArray,
                ...order,
              }}
              {...{
                getFieldDecorator,
                getFieldValue,
                setFieldsValue,
                type: 'purchase',
                vendorID: owner,
                title: 'VENDOR DETAILS',
                showProfit: isReqSale,
                showCost: !isReqSale,
                showRepEmail:true,
              }}
            />
          </Row>

          <Row style={{ paddingBottom: '10px', paddingTop: '10px' }}>
            <h3 style={{ color: 'rgb(43,187,143' }}>PURCHASE ORDER DETAILS</h3>
          </Row>
          <Row>
            <Col span={12}>
              <Form.Item {...threeFormItemLayout} label={'Vendor Quote'}>
                {getFieldDecorator('quote._id', {
                  initialValue: get(order, 'quote._id') || get(VendorQuote, '_id'),
                })(
                  <QuoteSelect
                    keyAtr={'_id'}
                    valueAtr={'display'}
                    placeholder="Select a Quote"
                    style={{ width: '80%' }}
                  />
                )}
                <InfoTooltip title={'Quote must be confirmed to appear in List'} />
                <Link target={'_blank'} to={`/purchasing/vendor/quotes/${quoteId}/update`}>
                  <Icon style={{ marginLeft: 5 }} type="fullscreen" />
                </Link>
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item {...threeFormItemLayout} label={'Order For'}>
                {getFieldDecorator('orderType', {
                  initialValue: get(order, 'orderType') || get(selectionData, '[0].orderType'),
                  rules: rules.select,
                })(<OrderTypeSelect />)}
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item {...threeFormItemLayout} label={'Order Date'}>
                {getFieldDecorator('date', {
                  initialValue: dateVal(order, 'date') || moment(),
                  rules: [{ required: true, message: 'Please Select a Order Date!' }],
                })(<DatePicker style={{ width: '100%' }} />)}
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={18}>
              <Form.Item {...fullWidthFormItemLayout} label={'Title '}>
                {getFieldDecorator('title', {
                  initialValue: get(order, 'title') || get(VendorQuote, 'title'),
                  rules: [{ required: true, message: 'Please Select a Title!' }],
                })(<Input placeholder={'Title'} />)}
                <IconText
                  text={
                    showDesc !== true ? 'Optionally Add Order Summary Description' : 'Remove Order Summary Description'
                  }
                  type={showDesc !== true ? 'plus-circle' : 'minus-circle'}
                  onClick={() => setShowDesc(!showDesc)}
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item {...boolLabelItemLayout} label={'USE REQ NUMBERING'}>
                {getFieldDecorator('useReqNum', {
                  initialValue: get(order, 'useReqNum') || true,
                  valuePropName: 'checked',
                })(<Checkbox placeholder={'USE REQ NUMBERING'} />)}
              </Form.Item>
            </Col>
          </Row>
          {showDesc === true && (
            <Row>
              <Col span={24}>
                <Form.Item {...fullWidthFormItemLayout} label={'Summary'}>
                  {getFieldDecorator('description', {
                    initialValue: get(order, 'description'),
                    rules: rules.input,
                  })(<TextArea placeholder={'Order Summary'} />)}
                </Form.Item>
              </Col>
            </Row>
          )}
          {isService && (
            <Row>
              <Col span={24}>
                <Form.Item {...fullWidthFormItemLayout} label="Scope of Work">
                  {getFieldDecorator('scope', {
                    initialValue: get(order, 'scope'),
                    rules: rules.input,
                  })(<TextArea rows={7} />)}
                </Form.Item>
              </Col>
            </Row>
          )}
          <Row>
            <MultiCurrency
              doc={{
                ...order,
                currency: get(order, 'currency') || get(VendorQuote, 'currency'),
              }}
              {...{
                getFieldDecorator,
                getFieldValue,
                setFieldsValue,
                type: 'purchase',
              }}
            />
            <Col span={8}>
              <Form.Item {...threeFormItemLayout} label="Value Type">
                {getFieldDecorator('valueType', {
                  initialValue: get(order, 'valueType') || 'Fixed & Firm',
                })(<TypeValue style={{ width: '80%' }} />)}
              </Form.Item>
            </Col>
            {typeValue !== 'fixed&firm' && typeValue && (
              <Col span={8}>
                <Form.Item {...threeFormItemLayout} label="Maximum Amount">
                  {getFieldDecorator('max', {
                    initialValue: get(order, 'max') || max,
                    rules: rules.select,
                  })(<InputNumber style={{ width: '80%' }} />)}
                </Form.Item>
              </Col>
            )}
            <Taxes
              doc={order}
              {...{
                getFieldDecorator,
                getFieldValue,
                setFieldsValue,
                resetFields,
                type: 'Purchase',
                //price: lines ? sum(lines.map(d => numVal(d, 'amount.net'))) : 0,
                hideRate: true,
              }}
            />
          </Row>

          <Row style={{ paddingBottom: '10px', paddingTop: '10px' }}>
            <h3 style={{ color: 'rgb(43,187,143' }}>TERMS & CONDITIONS</h3>
          </Row>

          <Row>
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label="Order Validity Start">
                {getFieldDecorator('validityStart', {
                  initialValue: dateVal(order, 'validityStart') || moment(),
                  rules: rules.date,
                })(
                  <DatePicker
                    style={{ width: '100%' }}
                    onChange={(e) => setFieldsValue({ validityEnd: moment(e).add(1, 'M') })}
                  />
                )}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label="Order Validity End">
                {getFieldDecorator('validityEnd', {
                  initialValue: dateVal(order, 'validityEnd') || moment().add(1, 'M'),
                  rules: rules.date,
                })(<DatePicker style={{ width: '100%' }} />)}
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item {...fullWidthFormItemLayout} label="Payment Terms">
                {getFieldDecorator('paymentTerm', {
                  initialValue: get(order, 'paymentTerm') || 'Account',
                  rules: rules.select,
                })(<PaymentTermValue />)}
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item {...fullWidthFormItemLayout} label="Special Conditions">
                {getFieldDecorator('condition', {
                  initialValue: get(order, 'condition'),
                })(<TextArea rows={7} />)}
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <Form.Item {...boolLabelItemLayout} label="Requires Inspection for release">
                {getFieldDecorator('qaRequirements.isReleaseInspection', {
                  initialValue: get(order, 'qaRequirements.isReleaseInspection'),
                  valuePropName: 'checked',
                })(<Checkbox />)}
              </Form.Item>
            </Col>
          </Row>
          <DeliveryDetails
            doc={order}
            {...{
              getFieldDecorator,
              getFieldValue,
              setFieldsValue,
              resetFields,
              type: 'Purchase',
            }}
          />
          {isCollection && (
            <Fragment>
              <Row style={{ paddingBottom: '10px', paddingTop: '10px' }}>
                <h3 style={{ color: 'rgb(43,187,143' }}>COLLECTION DETAILS</h3>
              </Row>
              <Row>
                <Col span={24}>
                  <Form.Item {...fullWidthFormItemLayout} label="Address Label">
                    {getFieldDecorator('collection.address.label', {
                      initialValue: get(order, 'collection.address.label'),
                      rules: rules.input,
                    })(<Input placeholde={'label'} />)}
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item {...defaultFormItemLayout} label="Email">
                    {getFieldDecorator('collection.address.email', {
                      initialValue: get(order, 'collection.address.email'),
                      rules: rules.input,
                    })(<Input placeholde={'Notify Email'} />)}
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item {...defaultFormItemLayout} label="Notify">
                    {getFieldDecorator('collection.address.notify', {
                      initialValue: get(order, 'collection.address.notify'),
                      rules: rules.input,
                    })(<Input placeholde={'Notify Name'} />)}
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item {...defaultFormItemLayout} label="Tel">
                    {getFieldDecorator('collection.address.tel', {
                      initialValue: get(order, 'collection.address.tel'),
                    })(<Input placeholde={'Notify Tel'} />)}
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item {...defaultFormItemLayout} label="Country">
                    {getFieldDecorator('collection.address.country', {
                      initialValue: get(order, 'collection.address.country'),
                      rules: rules.select,
                    })(<CountrySelect />)}
                  </Form.Item>
                </Col>
                {collectionCountry && (
                  <Col span={12}>
                    <Form.Item {...defaultFormItemLayout} label="Location">
                      {getFieldDecorator('collection.address.location', {
                        initialValue: get(order, 'collection.address.location'),
                        rules: rules.select,
                      })(<CollectionLocationSelect keyAtr={'locode'} valueAtr={'location'} />)}
                    </Form.Item>
                  </Col>
                )}
              </Row>
            </Fragment>
          )}
        </Row>
      </Form>
    </CustomSpin>
  )
}

/*const RequisitionsTypeSelect = compose(
  withSelectFetch({
    dropdown: 'requisitions',
    name: 'type',
  }),
  withSpinning,
  withSort,
)(CustomSelect)*/

const PaymentTermValue = compose(
  withSelectFetch({
    dropdown: 'purchase',
    name: 'paymentTerms',
  }),
  withSpinning,
  withSort
)(CustomSelect)

const TypeValue = compose(
  withSelectFetch({
    dropdown: 'purchase',
    name: 'valueType',
  }),
  withSpinning,
  withSort
)(CustomSelect)

export default Form.create()(ReadyToOrderForm)
